import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";
import * as actionTypes from "./actionTypes";
import { notify } from "../../helpers/utility";

export const leadDataStart = () => {
  return {
    type: actionTypes.LEAD_DATA_START,
  };
};

export const leadDataFail = (error) => {
  return {
    type: actionTypes.LEAD_DATA_FAIL,
    error: error,
  };
};

export const leadDataSuccess = (leads) => {
  return {
    type: actionTypes.LEAD_DATA_SUCCESS,
    leads: leads,
  };
};

export const leadDataUpdate = (leads) => {
  return {
    type: actionTypes.LEAD_DATA_UPDATE,
    leads: leads,
  };
};

export const leadData = (
 
  agentId,
  dialerType,
  leadType,
  inputValue,
  inputType,
  dateRange
) => {
  return (dispatch) => {
    dispatch(leadDataStart());

    // Modify the properties of ctiRequest["CTI_AGENT_LEAD_INFO"] based on the input parameters
    ctiRequest["CTI_AGENT_LEAD_INFO"].agent_id = agentId;
    ctiRequest["CTI_AGENT_LEAD_INFO"].dialer_type = dialerType;
    leadType =
      leadType === 0
        ? "fresh"
        : leadType === 1 || leadType === 2
        ? "scheduled"
        : leadType === 3
        ? "finished"
        : leadType === 4
        ? "abnlist"
        : "all";
    ctiRequest["CTI_AGENT_LEAD_INFO"].lead_type = leadType;
    ctiRequest["CTI_AGENT_LEAD_INFO"].input_value = inputValue;
    ctiRequest["CTI_AGENT_LEAD_INFO"].date_range = dateRange ;
    ctiRequest["CTI_AGENT_LEAD_INFO"].input_type = inputType;
    ctiRequest["CTI_AGENT_LEAD_INFO"].ip = window.clientIP;

    axios
      .post("/", ctiRequest["CTI_AGENT_LEAD_INFO"])
      .then((result) => {
        // Handle the response from the POST request
        if (
          result.data.response.status === "SUCCESS" ||
          (result.data.response.status === "FAILURE" &&
            result.data.response.reason === "No Data Availabe.")
        ) {
          dispatch(leadDataSuccess(result.data.response.lead_data));
        } else {
          dispatch(leadDataFail(result.data.response.reason));
          notify("Lead Error" + result.data.response.reason, "lead-dial");
        }
      })
      .catch((err) => {
        dispatch(leadDataFail(err));
      });
  };
};
